/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag Fragment */
import { Box, Image, Text, UnstyledButton } from '@mantine/core';
import { IconHeartFilled, IconHeartPlus } from '@tabler/icons-react';
import React, { Fragment } from 'react';
import { jsx } from 'theme-ui';
import getMantineCloudinaryImage from './getMantineCloudinaryImage';

export default function FloorPlanAreaPopover({
  title,
  imagePublicId,
  isFavorite,
  toggleFavorite,
  width = 160,
  height = width / 2,
}: {
  title: string;
  imagePublicId: string | null | undefined;
  isFavorite?: boolean;
  width?: number;
  height?: number;
  toggleFavorite?: () => void;
}) {
  return (
    <>
      <Text
        size="xs"
        lineClamp={3}
        sx={{ mb: 1 }}
        c="inherit"
        maw={width}
        title={title}
      >
        {title}
      </Text>
      <Box style={{ position: 'relative' }}>
        <Box w={width} h={height} bg="gray.4">
          {imagePublicId ? (
            <Image
              {...getMantineCloudinaryImage({
                layout: 'constrained',
                src: imagePublicId,
                width,
                height,
                loader: ({ src, width, height, quality }) =>
                  `https://res.cloudinary.com/bottlebooks/image/upload/w_${width},h_${height},c_fill,g_faces:auto,f_auto,q_${quality}/${src}`,
              })}
              alt={title}
              sx={{ border: 1, borderColor: 'currentColor' }}
            />
          ) : null}
        </Box>
        {toggleFavorite ? (
          <UnstyledButton
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              if (!toggleFavorite) return;
              e.preventDefault();
              e.stopPropagation();
              return toggleFavorite();
            }}
            c="white"
            pos="absolute"
            bottom={1}
            right={1}
          >
            {isFavorite ? (
              <IconHeartFilled />
            ) : (
              <IconHeartPlus fill="rgba(255,255,255,0.3)" />
            )}
          </UnstyledButton>
        ) : null}
      </Box>
    </>
  );
}
